import { useEffect } from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'

import { parseString } from '../../utils/utils'

export default function Home() {
    const navigate = useNavigate()
    const { user, config, accessToken, userPermissions, userPermissionsSummary, accordionData: sidebarAccordionData  } = useOutletContext()

    useEffect(() => {    //loading this route just redirects to the dashboard page
        
        // load accessToken if its in local storage
        const storedToken = parseString(localStorage.getItem('accessToken'))
        if (!storedToken) {
            // user not logged in. Redirect to SSO
            // const url = `${config.ssoBaseUrl}?clientid=4&redirectToReferer=true`
            // navigate(url)
            return
        }
        
        // check localstorage to see if user has a saved business entity selected. navigate to either it or the defualt for their user account
        let businessEntityId = user.businessEntityId
        const item = window.localStorage.getItem('selectedBusinessEntityId')
        if (item && item != "0") {
            businessEntityId = item
        }
        navigate(`/be/${businessEntityId}/dashboard`)
    }, [navigate, user.businessEntityId])
}